import { render, staticRenderFns } from "./FormPropertyInformation.vue?vue&type=template&id=abbff6f0&scoped=true&"
import script from "./FormPropertyInformation.vue?vue&type=script&lang=js&"
export * from "./FormPropertyInformation.vue?vue&type=script&lang=js&"
import style0 from "./FormPropertyInformation.scss?vue&type=style&index=0&id=abbff6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_@vue+compiler-sfc@3.5.11_babel-core@7.0.0-bridge.0_@babel+core@7.17.9_f17ab4d8c27c5d7082708fbbc2f82c9d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbff6f0",
  null
  
)

export default component.exports